export default "__VITE_ASSET__bd38f324__"